import req from './../../../../fetch';
import { undocumentedResponse } from './../../../../utils';
import { NetworkType, AllAPIResponses, CarbonError } from './../../../../index';

type Params = {
  id: number;
  networkType: NetworkType;
};
const del = async (
  params: Params,
  headers?: Headers
): Promise<AllAPIResponses<{}>> => {
  const resp = await req.del(
    `/api/claims/${params.networkType}/${params.id}`,
    '',
    headers
  );

  try {
    const clone = resp.clone();
    switch (resp.status) {
      case 204:
        return {
          data: {},
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};
export default del;
